// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__oBdvZ","icon":"Button_icon__Q7_At","title":"Button_title__j81Ii","text":"Button_text__ObOeT"};